var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85827 0.466243C6.06026 -0.155416 6.93974 -0.155412 7.14173 0.466243L8.36509 4.23135H12.324C12.9776 4.23135 13.2494 5.06779 12.7206 5.45199L9.51777 7.77895L10.7411 11.5441C10.9431 12.1657 10.2316 12.6827 9.70279 12.2985L6.5 9.97149L3.29721 12.2985C2.76839 12.6827 2.05688 12.1657 2.25887 11.5441L3.48223 7.77895L0.279437 5.45199C-0.249378 5.06778 0.0223989 4.23135 0.676047 4.23135H4.63491L5.85827 0.466243ZM6.5 1.61056L5.48674 4.72904C5.39641 5.00705 5.13734 5.19528 4.84502 5.19528H1.56605L4.21879 7.12261C4.45528 7.29443 4.55424 7.59899 4.46391 7.87701L3.45065 10.9955L6.10339 9.06816C6.33988 8.89634 6.66012 8.89634 6.89661 9.06816L9.54935 10.9955L8.53609 7.87701C8.44576 7.59899 8.54472 7.29443 8.78121 7.12261L11.4339 5.19528H8.15498C7.86266 5.19528 7.60359 5.00705 7.51326 4.72904L6.5 1.61056Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b46b33f037a4c7c55018a56f9b5dc5bf.svg";
export { ForwardRef as ReactComponent };